import { render, staticRenderFns } from "./deck-form.vue?vue&type=template&id=e0d03ef8&"
import script from "./deck-form.vue?vue&type=script&lang=js&"
export * from "./deck-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports